module.exports = __webpack_public_path__ + "media/images/openweather/owm-28fdfb01e53309569a204153fd4f1703.ico";